define('boxes/deposit-bonus/deposit-bonus-model',['jquery', 'boxes/events/bonus-event', 'boxes/events/paymentEvent', 'boxes/box', 'boxes/helpers/box-loading', 'boxes/helpers/message-popup', 'all/lib/slick'],
	function ($, bonusEvent, paymentEvent, box, boxLoading, messagePopup) {
    'use strict';

    function setupUIEventHandlers(depositBonus) {
        var $bonusElement = depositBonus.$box.find('.bonuses'),
            $bonusElements = $bonusElement.find('.bonus-item');

        $bonusElements.find('.ui-button').off();
        $bonusElements.find('.ui-button').on('click', function () {
            var $bonusEl = $(this).parent().parent();
			var bonusData = {
				id: $bonusEl.data('bonus-id'),
				title: $bonusEl.data('bonus-title'),
				description: $bonusEl.data('bonus-description'),
				resourceUrl: $bonusEl.data('bonus-resourceurl'),
				isFree: $bonusEl.data('bonus-isfree'),
				isMerch: $bonusEl.data('is-merch'),
				includedPaymentMethodIds: $bonusEl.data('bonusPaymentMethodIds'),
				depositBonus: depositBonus
			};


			var iconXLargeResourcekey = $bonusEl.data('bonus-addon-iconxlarge');
			var iconLargeResourcekey = $bonusEl.data('bonus-addon-iconlarge');
			var extraLargeResourceUrl = $bonusEl.data('bonus-extralargeresourceurl');
			var bonusResourceUrl = $bonusEl.data('bonus-resourceUrl');
			if(iconXLargeResourcekey){
				bonusData.resourceUrl = iconXLargeResourcekey;
			}else if(iconLargeResourcekey){
				bonusData.resourceUrl = iconLargeResourcekey;
			}else if(extraLargeResourceUrl) {
				bonusData.resourceUrl = extraLargeResourceUrl;
			}else if(bonusResourceUrl){
				bonusData.resourceUrl = bonusResourceUrl;
			}

            var $bonusButton = $(this);

			if(bonusData.isMerch) {
				//hide the arrows if this is a bonus with popup
				toggleCarouselArrows(false, depositBonus);

				messagePopup.show(depositBonus.$box, 'merchandise-popup',{
					"id": $bonusEl.data('bonus-id'),
					"merch-offer-header": $bonusEl.data('merch-offer-header'),
					"merch-offer-text": $bonusEl.data('merch-offer-text'),
					"merch-offer-accept": $bonusEl.data('merch-offer-accept'),
					"merch-offer-decline": $bonusEl.data('merch-offer-decline')
				}, {
					confirmButtonCallback: function (event) {
						event.preventDefault();
						if(isMultipleSelectionBonus($bonusEl)) {
							var multipleSelectionPopup = messagePopup.show(depositBonus.$box, 'merchandise-multiple-popup', {
								"merch-offer-options-header": $bonusEl.data('merch-offer-options-header'),
								"merch-offer-options-placeholder": $bonusEl.data('merch-offer-options-placeholder'),
								"merch-offer-options": $bonusEl.data('merch-offer-options'),
								"merch-offer-options-accept": $bonusEl.data('merch-offer-options-accept'),
								"merch-offer-options-cancel": $bonusEl.data('merch-offer-options-cancel')
							}, {
								confirmButtonCallback: function (event) {
									event.preventDefault();
									//find which option is selected
									//add selected option to bonus data
									bonusData.addonId = $bonusEl.data('bonus-addon-id');
									bonusData.addonChosenOptionId = depositBonus.$box.find('#merch-offer-options').find(':selected').val();
									if(bonusData.addonChosenOptionId !== "") {
										$bonusButton.off();
										boxLoading.showLoading(depositBonus.$box);
										sendBonusDataToAmountPage(depositBonus, bonusData);
										depositBonus.$controller.nextBox();
									}
								},
								closeButtonCallback: function (event) {
									event.preventDefault();
									//turn on arrows back again
									toggleCarouselArrows(true,depositBonus);
								}
							});

							multipleSelectionPopup.find('.confirm').addClass('disabled');

							multipleSelectionPopup.find('#merch-offer-options').one('change', function(event) {
								multipleSelectionPopup.find('.confirm').removeClass('disabled');
							});
						} else {
							//add single option to bonus data
							bonusData.addonId = $bonusEl.data('bonus-addon-id');
							sendBonusDataToAmountPage(depositBonus, bonusData);
							depositBonus.$controller.nextBox();
						}
					},
					closeButtonCallback: function (event) {
						//move to next screen because we dont want merch offer
						$bonusButton.off();
						boxLoading.showLoading(depositBonus.$box);
						sendBonusDataToAmountPage(depositBonus, bonusData);
						depositBonus.$controller.nextBox();
					}
				});
			} else if(bonusData.isFree) {
				//take freemoney bonus
				//dont move to next screen
				redeemFreeMoneyBonusFromCarousel(depositBonus, bonusData);
			} else {
				$bonusButton.off();
				boxLoading.showLoading(depositBonus.$box);
				sendBonusDataToAmountPage(depositBonus, bonusData);
				depositBonus.$controller.nextBox();
			}
        });

        depositBonus.$box.find('.ui-button.ui-button-skip').off().on('click', function (e) {
            e.preventDefault();
            $(this).off();
            depositBonus.$controller.trigger(bonusEvent.NO_SELECTED_BONUS);
            boxLoading.showLoading(depositBonus.$box);
            depositBonus.$controller.nextBox();
        });
    }

	function sendBonusDataToAmountPage(depositBonus, bonusData) {
		depositBonus.$controller.trigger(bonusEvent.BONUS_CHANGED, bonusData);
	}

	function isMultipleSelectionBonus($bonusElement) {
		var arr = $bonusElement.data('merch-offer-options');
		if(Array.isArray(arr) && arr.length > 0) {
			return true;
		} else {
			return false;
		}
	}

	function redeemFreeMoneyBonusFromCarousel (depositBonus, bonusData) {
		boxLoading.showLoading(depositBonus.$box);
		$.ajax({
			url: '/pp?flow=GetDepositVerification',
			data: {isBonusSelected: true, isBonusFree: true},
			type: 'GET'
		}).done(function (data) {
			if (!data.verifyEmail && !data.verifyMobile) {
				$.ajax({
					url: '/pp?flow=RedeemFreeBonus',
					data: {PARAM_BONUS_ID: bonusData.id},
					type: 'GET'
				}).done(function (data) {
					if(data.RESULT === "OK") {
						toggleCarouselArrows(false,depositBonus);
						messagePopup.show(depositBonus.$box, 'message-popup', {
							'title': data.TEXT,
							'closeButtonText': data.BUTTON_TEXT
						}, {
							closeButtonCallback: function () {
								removeBonusFromCarousel(bonusData.id, depositBonus);
								toggleCarouselArrows(true,depositBonus);
							}
						});
					} else if(data.RESULT === "NOT_OK") {
						toggleCarouselArrows(false,depositBonus);
						messagePopup.show(depositBonus.$box, 'message-popup', {
							'title': data.ERROR_HEADER,
							'message': data.ERROR
						}, {
							closeButtonCallback: function () {
								toggleCarouselArrows(true,depositBonus);
							}
						});
					}
				}).fail(function () {
					console.log('free money bonus redeem fail');
				});
			} else {
				if(data.verifyEmail || data.verifyMobile) {
					bonusData.fromCarousel = true;
					bonusData.verifyEmail = data.verifyEmail;
					bonusData.verifyMobile = data.verifyMobile;
					sendBonusDataToAmountPage(depositBonus, bonusData);
					depositBonus.$controller.nextBox();
				}
			}
		}).fail(function () {
			console.log('free money bonus verification fail');
		}).always(function () {
			boxLoading.removeLoading(depositBonus.$box);
		});
	}

    function setupEventHandlers(depositBonus) {
        depositBonus.$controller.on('SHOW_MESSAGE_SUCCESS', function () {
            depositBonus.$box.find('.message-success').show();
        });
    }

	function clearPreviousPopups (depositBonus) {
		depositBonus.$box.find('.overlay.ui-animation').remove();
	}

	function toggleCarouselArrows (bool, depositBonus) {
		bool ? depositBonus.$box.find('.slick-arrow').show() : depositBonus.$box.find('.slick-arrow').hide();
	}

    function createCarousel(bonusId, depositBonus) {
    	var slickConfigObj = {
			dots: true,
			draggable: false,
			infinite: false,
			arrows: true,
			centerMode: true,
			centerPadding: "100px",
			prevArrow: '<button type="button" class="slick-prev"><div class="chevron-wrapper"><div class="chevron-left"></div></div></button>',
			nextArrow: '<button type="button" class="slick-next"><div class="chevron-wrapper"><div class="chevron-right"></div></div></button>'

		};

		var $carousel = $(depositBonus.$controller.$controller.selector).find('#slick-bonus-carousel');
		if($carousel.children().length == 1){
			slickConfigObj.centerPadding = "50px";
		}

		replaceAddonHeaders($carousel.children());

		$carousel.slick(slickConfigObj);
		if(bonusId) {
			var $chosenBonus = $carousel.find('[data-bonus-id='+bonusId+']');
			if($chosenBonus.length > 0) {
				var index = $chosenBonus.data('slick-index');
				$carousel.slick('slickGoTo',index,false);
				$chosenBonus.find('.ui-button').trigger('click');
			} else {
				console.log('could not find your chosen bonus in the carousel');
			}
		}
	}

	function removeBonusFromCarousel (bonusId, depositBonus) {
		var $carousel = $(depositBonus.$controller.$controller.selector).find('#slick-bonus-carousel');
		var $bonusItem = $carousel.find('[data-bonus-id='+bonusId+']');
		if($bonusItem && $bonusItem.length > 0) {
			var index = $bonusItem.data('slick-index');
			$carousel.slick('slickRemove', index).slick('refresh');
			if($carousel.find('.slick-track').children().length === 1){
				$carousel.slick('slickSetOption', 'centerPadding', "50px", true);
			}
			else if($carousel.find('.slick-track').children().length === 0) {
				depositBonus.$controller.trigger(bonusEvent.NO_SELECTED_BONUS);
				depositBonus.$controller.nextBox();
			}
		} else {
			console.log('could not find id:'+bonusId+' in carousel');
		}
	}

	function replaceAddonHeaders ($elements) {
		$elements.each(function (i, elem) {
			if($(elem).data('bonus-addon-header') !== undefined) {
				$(elem).find('h3').text($(elem).data('bonus-addon-header'));
			}
		})
	}

    function ajaxGetDepositBonusesPromise(depositBonus, depositBonusModel) {
        var parameterData = {};
        if (depositBonus.$controller.$controller.hasClass('signup')) {
            $.extend(parameterData, { includeFreeBonuses: true });
        }

        var ajaxPromise = box.ajax(depositBonus, {
            url: '/pp?flow=GetDepositBonuses',
            data: parameterData,
            type: 'GET'
        }, function (data, ajaxPromise) {
                if (data.RESULT === 'NOT_OK' || data.bonuses.length < 1) {
                    depositBonus.$controller.trigger(bonusEvent.NO_SELECTED_BONUS);
                    ajaxPromise.reject();
                } else {
					for(var i = 0; i < data.bonuses.length; i++) {
						var bonus = data.bonuses[i];
						if(bonus.bonusAddOn) {
							bonus.bonusAddOn.options = JSON.stringify(bonus.bonusAddOn.options);
							data.bonuses[i] = bonus;
						}
					}
                    depositBonusModel.bonusesData = data.bonuses;
                    ajaxPromise.resolve();
                }
        });
        return ajaxPromise.promise();
    }

    return {
        bonusesData: {},
        init: function (depositBonus) {
            setupEventHandlers(depositBonus);
        },
        beforeRender: function (depositBonus) {
            depositBonus.$controller.trigger(bonusEvent.RESET_VERIFICATION);
			clearPreviousPopups(depositBonus);

            var ajaxPromise = ajaxGetDepositBonusesPromise(depositBonus, this);
            return [ajaxPromise];
        },
        afterRender: function (depositBonus) {
            setupUIEventHandlers(depositBonus);
			function carousel() {
				createCarousel(depositBonus.model.chosenBonusId, depositBonus);
			}
			setTimeout(carousel, 400);
			//make sure the arrows are shown
			toggleCarouselArrows(true,depositBonus);
        }
    };
});

